// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__SkcwM","nodata":"topTable_nodata__1B5Cg"};